import { createStore, useStore, UseStoreHook } from '@lib/store'

export type GigyaStore = {
  user: Gigya.UserProfile | null
  isLoaded: boolean
}

const store = createStore<GigyaStore>({
  user: null,
  isLoaded: false,
})

export const useGigyaStore = (): UseStoreHook<GigyaStore> => useStore(store)

export default store
